import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Title from './dev/Title';
import Input from './dev/Input'
import Submit from './dev/Submit';
import Response from './dev/Response';
import LoadingSpinner from '../dev/LoadingSpinner'

const { REACT_APP_URI = '/' } = process.env
const isEmail = email => {
    const regex = /^([a-zA-Z0-9_.\-+])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (!regex.test(email)) {
        return false;
    }
    else {
        return true;
    }
}

class ForgetPassword extends Component {
    state={
        response: '',
        isLoading: false,
    }
    render() {
        const { response, isLoading } = this.state
        const { user: { email, token }, messages } = this.props
        const profileInput = condition => e => this.props.dispatch({ type: `${condition}Input`, [condition]: e.target.value })
        const profileSubmit = () => {
            if (isButtonActive() === 'disabled') return
            this.setState({ response: '', isLoading: true })
            fetch(`${REACT_APP_URI}/accounts/passwordForget/`, {
                method: 'post',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    "X-CSRFToken": token,
                },
                body: JSON.stringify({ email: email, })
            })
            .then(res => {
                const { status } = res
                if (status === 200) this.setState({ response: messages.user_email_verify, isLoading: false })
                if (status === 400) this.setState({ response: messages.user_has_not_been_taken, isLoading: false})
            })
        }
        const isButtonActive = () => {
            if (isEmail(email) && email !== '') return ''
            else return 'disabled'
        }
        return (
            <Container>
                <div>
                    <Title>{messages.user_forget_password}</Title>
                    <Input
                        onInput={profileInput('email')} value={email}
                        onKeyPress={e => e.key === "Enter" && profileSubmit()}
                        type="email" name="email" placeholder={messages.user_your_email} autoFocus />
                    <Submit onClick={profileSubmit} disabled={isButtonActive()}>{messages.user_send_email}</Submit>
                    {response !== '' && <Response>{response}</Response>}
                    {isLoading && <LoadingSpinner/>}
                </div>
                <Footer>
                    <div onClick={() => this.props.dispatch({ type: 'changeUserCondition', condition: 'register' })}>{messages.user_signup}</div>
                    <div onClick={() => this.props.dispatch({ type: 'changeUserCondition', condition: 'signIn' })}>{messages.nav_login}</div>
                </Footer>
            </Container>
        )
    }
}
const mapStateToProps = state => {
    return {
        user: state.User,
        messages: state.Messages
    }
}
export default connect(mapStateToProps)(ForgetPassword);
const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    min-height: 270px;
`
const Footer = styled.div`
    display: flex;
    justify-content: flex-end;    
    width: 100%;
    font-size: 14px;
    font-weight: 300;
    cursor: pointer;
    text-decoration: underline;
    div {
        margin-right: 16px;
    }
`


// WEBPACK FOOTER //
// ./src/User/ForgetPassword.js